<template>
  <v-row justify="center">
    <v-col cols="12" sm="8" md="7">
      <v-card class="help pa-5" outlined>
        <v-card-title>
          <h1>Need some help?</h1>
        </v-card-title>
        <v-card-text>
          <p class="text-h6">
            Email us at
            <a
              class="email-link d-inline-block"
              :href="`mailto:${getShopDetail('Contact Email')}`"
              >{{ getShopDetail('Contact Email') }}</a
            >
          </p>
          <AirtableHtml setting-name="Help Page" />
        </v-card-text>
      </v-card>
      <v-row justify="center" class="my-4">
        <v-btn exact depressed dark x-large color="blue" to="/menu" class="mt-4"
          >View the Menu</v-btn
        >
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import AirtableHtml from '@/components/AirtableHtml'

export default {
  name: 'Help',
  components: { AirtableHtml },
  computed: {
    ...mapGetters('shop', ['getShopDetail']),
  },
  data() {
    return {}
  },
}
</script>
